import { api, headers } from "@/config/axiosInstance";
import { env } from "@/config/env";
import {
  ClientByCodeDto,
  ClientIndexPaginatedDto,
  ClientIndexQueryDto,
  ClientStoreDto,
} from "@/pages/clients/types";

export const useClient = () => {
  const getClients = ({
    page,
    storeId,
    codeOrNameOrClass,
    situation,
  }: ClientIndexQueryDto) => {
    let params = `page=${page}&perPage=${env.per_page}`;

    if (codeOrNameOrClass) {
      params = `${params}&codeOrNameOrClass=${codeOrNameOrClass}`;
    }

    if (situation) {
      params = `${params}&situation=${situation}`;
    }

    return api.get<ClientIndexPaginatedDto>(
      `/client/${storeId}/index?${params}`
    );
  };

  const clientStore = (storeId: number, data: ClientStoreDto) => {
    return api.post<ClientIndexPaginatedDto>(`/client/${storeId}/create`, data);
  };

  const clientSituationUpdate = (id: number, situation: boolean) => {
    return api.patch(`/client/${id}/situation-update`, { situation });
  };

  const clientImport = (storeId: number, file: any) => {
    const formData = new FormData();
    formData.append("file", file);

    return api.post(`client/${storeId}/file`, formData, {
      headers: { ...headers, "Content-Type": "multipart/form-data" },
    });
  };

  const getClientByCode = (storeId: number, code: string) => {
    return api.get<ClientByCodeDto>(`/client/${storeId}/${code}`);
  };

  return {
    getClients,
    clientStore,
    clientSituationUpdate,
    clientImport,
    getClientByCode,
  };
};
